// import api from '../../utils/axios'
import api from '../../utils/request'
// 根据部门、情形ID查询材料和表单
export function getTemplateForm(query) { 
  return api({
      url: '/zwmap/getDeptMaterialByDeptTemplate',
      method: 'post',
      data: query
  })
}
// 在线申请--提交   {idCard:'',phone:'',templateId:'',createBy:'',matterName:'',deptId:'',deptMatterId:[],materialList:[{deptMaterialId:'',url:'',idCard:''}],applyForm:{formValue:'',createBy:''}}
export function submitForm(query) { 
  return api({
      url: '/zwmap/submit',
      method: 'post',
      data: query
  })
}
// 材料复用 deptMaterialId  idCard
export function MaterialReuse(query) { 
  return api({
      url: '/zwmap/materialMultiplex',
      method: 'post',
      data: query
  })
}
// 退出登录   token userId
export function logout(query) { 
  return api({
      url: '/zwmap/logout',
      method: 'post',
      data: query
  })
}
// 修改用户信息   
export function updateUser(query) { 
  return api({
      url: '/zwmap/updateUser',
      method: 'post',
      data: query
  })
}
// 查询用户材料 idCard
export function updateUserFiles(query) { 
  return api({
      url: '/zwmap/selectUserFile',
      method: 'post',
      data: query
  })
}
// 更新用户材料   id  url
export function updateUserFile(query) { 
  return api({
      url: '/zwmap/updateUserFile',
      method: 'post',
      data: query
  })
}
// 办件列表
export function getHandlingList(query) { 
  return api({
      url: '/zwmap/getHandlingList',
      method: 'post',
      data: query
  })
}
// 办件详情
export function getHandlingDetails(query) { 
  return api({
      url: '/zwmap/getHandlingDetails',
      method: 'post',
      data: query
  })
}

// 重新上传材料   提交材料id：idsubmitId;材料地址 url;申请id applyId;事项id matterId;
export function uploadMaterial(query) { 
  return api({
      url: '/zwmap/uploadMaterial',
      method: 'post',
      data: query
  })
}

// 下载材料
export function download(data) {
  return api({
    url: `/zwmap/governmentMap/download`,
    method: "get",
    // responseType: "blob",
    params: data,
  });
}
